import React from "react";

import { MessageDescriptor } from "react-intl";

import { Inline } from "@atlaskit/primitives-next";

import { TAB_KEYS } from "../constants";
import { useResourcesPageUIAnalytics } from "../hooks";

import { TabPill } from "./tab-pill";

interface TabSelectorProps {
    currentTab: TAB_KEYS;
    tabs: {
        id: TAB_KEYS;
        icon: React.ReactNode;
        text: MessageDescriptor;
    }[];
    onTabSelect: (id: TAB_KEYS) => void;
}

export const TabSelector: React.FC<TabSelectorProps> = ({
    currentTab,
    tabs,
    onTabSelect
}) => {
    const { sendResourceFilterClickUIEvent } = useResourcesPageUIAnalytics();

    const handleTabSelect = (tabId: TAB_KEYS) => {
        onTabSelect(tabId);
        sendResourceFilterClickUIEvent(tabId);
    };

    return (
        <Inline alignBlock="center" space="space.100" shouldWrap>
            {tabs.map((tab) => (
                <TabPill
                    key={tab.id}
                    icon={tab.icon}
                    text={tab.text}
                    isSelected={tab.id === currentTab}
                    onSelect={() => handleTabSelect(tab.id)}
                />
            ))}
        </Inline>
    );
};
